



























































































































































































































































































import Vue from 'vue';
import ProductToggleSection from '@/web/components/products/ProductToggleSection.vue';
import ProductEditSection from '@/web/components/products/ProductEditSection.vue';
import { mapGetters } from 'vuex';
import { debounce, get, set, cloneDeep, has } from 'lodash';
import HMSwitchTabs from '@/web/components/common/HMSwitchTabs.vue';
import ProductSalesPageIntroduction from '@/web/components/products/sales-page/ProductSalesPageIntroduction.vue';
import ProductSalesPageSolution from '@/web/components/products/sales-page/ProductSalesPageSolution.vue';
import ProductSalesPageSignUpBanner from '@/web/components/products/sales-page/ProductSalesPageSignUpBanner.vue';
import ProductSalesPageResults from '@/web/components/products/sales-page/ProductSalesPageResults.vue';
import ProductSalesPageBonus from '@/web/components/products/sales-page/ProductSalesPageBonus.vue';
import ProductSalesPageIncludedContent from '@/web/components/products/sales-page/ProductSalesPageIncludedContent.vue';
import ProductSalesPageIncludedEvents from '@/web/components/products/sales-page/ProductSalesPageIncludedEvents.vue';
import ProductSalesPageIncludedLessons from '@/web/components/products/sales-page/ProductSalesPageIncludedLessons.vue';
import ProductSalesPageInstructors from '@/web/components/products/sales-page/ProductSalesPageInstructors.vue';
import ProductSalesPageFAQItem from '@/web/components/products/sales-page/ProductSalesPageFAQItem.vue';
import ProductSalesPageTestimonialItem from '@/web/components/products/sales-page/ProductSalesPageTestimonialItem.vue';
import { notify } from '@/web/utils/notify';

const defaultSectionState: { enabled: boolean } = {
  enabled: false,
};

export default Vue.extend({
  name: 'ProductSalesPage',
  components: {
    ProductToggleSection,
    ProductEditSection,
    HMSwitchTabs,
    ProductSalesPageIntroduction,
    ProductSalesPageSolution,
    ProductSalesPageSignUpBanner,
    ProductSalesPageResults,
    ProductSalesPageBonus,
    ProductSalesPageIncludedContent,
    ProductSalesPageIncludedEvents,
    ProductSalesPageIncludedLessons,
    ProductSalesPageInstructors,
    ProductSalesPageFAQItem,
    ProductSalesPageTestimonialItem,
  },
  computed: {
    ...mapGetters({
      productSalesPage: 'product/productSalesPage',
      productForm: 'product/productForm',
    }),
    productId(): number {
      return parseInt(this.$route.params['id']);
    },
    isSimple: {
      get(): boolean {
        return get(this.productForm, 'sales_page.is_simple', true);
      },
    },
    isProductCourse(): boolean {
      return this.productForm.product_type === 'course';
    },
    salesPageVariant: {
      get(): string {
        const isSimple = get(
          this.productForm,
          'sales_page.is_simple',
          true
        ) as boolean;
        return isSimple ? 'simple' : 'advanced';
      },
      async set(value: string) {
        const isSimple = value === 'simple' ? true : false;
        const salesPage = get(this.productForm, 'sales_page', {
          product: this.productId,
        }) ?? {
          product: this.productId,
        };
        salesPage.is_simple = isSimple;

        const action = !salesPage.id ? 'create' : 'update';
        const result = await this.$store.dispatch(
          `product/${action}ProductSalesPage`,
          salesPage
        );
        this.$store.dispatch('product/setProductForm', {
          sales_page: { ...salesPage, ...result },
        });
      },
    },
    introduction(): ProductSalesPageIntroductionResponse {
      const introduction =
        get(this.productForm, 'sales_page.introduction', defaultSectionState) ??
        defaultSectionState;
      return introduction;
    },
    solution(): ProductSalesPageSolutionResponse {
      const solution =
        get(this.productForm, 'sales_page.solution', defaultSectionState) ??
        defaultSectionState;
      return solution;
    },
    signUpBanner(): ProductSalesPageSignUpBannerResponse {
      const signUpBanner =
        get(
          this.productForm,
          'sales_page.sign_up_banner',
          defaultSectionState
        ) ?? defaultSectionState;
      return signUpBanner;
    },
    testimonial(): ProductSalesPageTestimonialsResponse {
      const testimonial =
        get(this.productForm, 'sales_page.testimonial', defaultSectionState) ??
        defaultSectionState;
      return testimonial;
    },
    instructors(): ProductSalesPageInstructorsResponse {
      const instructors =
        get(this.productForm, 'sales_page.instructors', defaultSectionState) ??
        defaultSectionState;
      return instructors;
    },
    results(): ProductSalesPageResultsResponse {
      const results =
        get(this.productForm, 'sales_page.results', defaultSectionState) ??
        defaultSectionState;
      return results;
    },
    bonus(): ProductSalesPageBonusResponse {
      const bonus =
        get(this.productForm, 'sales_page.bonus', defaultSectionState) ??
        defaultSectionState;
      return bonus;
    },
    faq(): ProductSalesPageFAQsResponse {
      const faq =
        get(this.productForm, 'sales_page.faq', defaultSectionState) ??
        defaultSectionState;
      return faq;
    },
    includedContent(): ProductSalesPageIncludedContentResponse {
      const includedContent =
        get(
          this.productForm,
          'sales_page.included_content',
          defaultSectionState
        ) ?? defaultSectionState;
      return includedContent;
    },
    includedEvents(): ProductSalesPageIncludedEventsResponse {
      const includedEvents =
        get(
          this.productForm,
          'sales_page.included_events',
          defaultSectionState
        ) ?? defaultSectionState;
      return includedEvents;
    },
    includedLessons(): ProductSalesPageIncludedLessonsResponse {
      const includedLessons =
        get(
          this.productForm,
          'sales_page.included_lessons',
          defaultSectionState
        ) ?? defaultSectionState;
      return includedLessons;
    },
  },
  methods: {
    showGeneralError(err): void {
      this.$notify({
        group: 'app',
        type: 'error',
        title: this.$t('GENERAL.ERROR.GENERAL_ERROR') as string,
        text: err,
        duration: -1, // stay ON
      });
    },
    showSuccess(title, text): void {
      this.$notify({
        group: 'app',
        type: 'success',
        title: title,
        text: text,
      });
    },
    async createFAQ(): Promise<void> {
      const salesPage = await this.createOrReturnProductSalesPage();
      const faq = salesPage.faq;
      const data = {
        productId: this.productId,
        salesPageId: salesPage.id,
        faqsId: faq.id,
        payload: {},
      };
      try {
        const faqItem = await this.$store.dispatch(
          'product/createProductsSalesPageFAQ',
          data
        );
        faq.faqs = [...faq.faqs, faqItem];
        this.$store.dispatch('product/setProductForm', {
          sales_page: salesPage,
        });
        this.showSuccess(
          this.$t('PRODUCTS.MODAL.FAQ_CREATED') as string,
          this.$t('PRODUCTS.MODAL.FAQ_CREATED_DESCRIPTION') as string
        );
      } catch (err) {
        this.showGeneralError(err);
      }
    },
    async createTestimonial(): Promise<void> {
      const salesPage = await this.createOrReturnProductSalesPage();
      const testimonial = salesPage.testimonial;
      const data = {
        productId: this.productId,
        salesPageId: salesPage.id,
        testimonialsId: testimonial.id,
        payload: {},
      };
      try {
        const testimonialItem = await this.$store.dispatch(
          'product/createProductsSalesPageTestimonial',
          data
        );
        testimonial.testimonials = [
          ...testimonial.testimonials,
          testimonialItem,
        ];
        this.$store.dispatch('product/setProductForm', {
          sales_page: salesPage,
        });
        this.showSuccess(
          this.$t('PRODUCTS.MODAL.TESTIMONIAL_CREATED') as string,
          this.$t('PRODUCTS.MODAL.TESTIMONIAL_CREATED_DESCRIPTION') as string
        );
      } catch (err) {
        this.showGeneralError(err);
      }
    },
    async updateFAQ(item: CreateUpdateSalesPageFAQRequest): Promise<void> {
      const salesPage = await this.createOrReturnProductSalesPage();
      const faq = salesPage.faq;
      const data = {
        productId: this.productId,
        salesPageId: salesPage.id,
        faqsId: faq.id,
        faqId: item.id,
        payload: item,
      };
      try {
        const faqItem = await this.$store.dispatch(
          'product/updateProductsSalesPageFAQ',
          data
        );
        const faqIndex = faq.faqs.findIndex(f => f.id === faqItem.id);
        faq.faqs[faqIndex] = faqItem;
        this.$store.dispatch('product/setProductForm', {
          sales_page: salesPage,
        });
        this.showSuccess(
          this.$t('PRODUCTS.MODAL.FAQ_UPDATED') as string,
          this.$t('PRODUCTS.MODAL.FAQ_UPDATED_DESCRIPTION') as string
        );
      } catch (err) {
        this.showGeneralError(err);
      }
    },
    async updateTestimonial(
      item: CreateUpdateSalesPageTestimonialRequest
    ): Promise<void> {
      const salesPage = await this.createOrReturnProductSalesPage();
      const testimonial = salesPage.testimonial;
      const data = {
        productId: this.productId,
        salesPageId: salesPage.id,
        testimonialsId: testimonial.id,
        testimonialId: item.id,
        payload: item,
      };
      try {
        const testimonialItem = await this.$store.dispatch(
          'product/updateProductsSalesPageTestimonial',
          data
        );
        const testimonialIndex = testimonial.testimonials.findIndex(
          f => f.id === testimonialItem.id
        );
        testimonial.testimonials[testimonialIndex] = testimonialItem;
        this.$store.dispatch('product/setProductForm', {
          sales_page: salesPage,
        });
        this.showSuccess(
          this.$t('PRODUCTS.MODAL.TESTIMONIAL_UPDATED') as string,
          this.$t('PRODUCTS.MODAL.TESTIMONIAL_UPDATED_DESCRIPTION') as string
        );
      } catch (err) {
        this.showGeneralError(err);
      }
    },
    async removeFAQ(item: CreateUpdateSalesPageFAQRequest): Promise<void> {
      const salesPage = await this.createOrReturnProductSalesPage();
      const faq = salesPage.faq;
      const data = {
        productId: this.productId,
        salesPageId: salesPage.id,
        faqsId: faq.id,
        faqId: item.id,
      };
      try {
        const faqItem = await this.$store.dispatch(
          'product/removeProductsSalesPageFAQ',
          data
        );
        const faqIndex = faq.faqs.findIndex(f => f.id === item.id);
        faq.faqs.splice(faqIndex, 1);
        this.$store.dispatch('product/setProductForm', {
          sales_page: salesPage,
        });
        this.showSuccess(
          this.$t('PRODUCTS.MODAL.FAQ_DELETED') as string,
          this.$t('PRODUCTS.MODAL.FAQ_DELETED_DESCRIPTION') as string
        );
      } catch (err) {
        this.showGeneralError(err);
      }
    },
    async removeTestimonial(
      item: CreateUpdateSalesPageTestimonialRequest
    ): Promise<void> {
      const salesPage = await this.createOrReturnProductSalesPage();
      const testimonial = salesPage.testimonial;
      const data = {
        productId: this.productId,
        salesPageId: salesPage.id,
        testimonialsId: testimonial.id,
        testimonialId: item.id,
      };
      try {
        const testimonialItem = await this.$store.dispatch(
          'product/removeProductsSalesPageTestimonial',
          data
        );
        const testimonialIndex = testimonial.testimonials.findIndex(
          f => f.id === item.id
        );
        testimonial.testimonials.splice(testimonialIndex, 1);
        this.$store.dispatch('product/setProductForm', {
          sales_page: salesPage,
        });
        this.showSuccess(
          this.$t('PRODUCTS.MODAL.TESTIMONIAL_DELETED') as string,
          this.$t('PRODUCTS.MODAL.TESTIMONIAL_DELETED_DESCRIPTION') as string
        );
      } catch (err) {
        this.showGeneralError(err);
      }
    },
    async createOrReturnProductSalesPage(): Promise<ProductSalesPageResponse> {
      const salesPage = get(this.productForm, 'sales_page', null);
      if (!salesPage || !salesPage.id) {
        const result = (await this.$store.dispatch(
          'product/createProductSalesPage',
          {
            product: this.productId,
            is_simple: this.isSimple,
          }
        )) as ProductSalesPageResponse;
        this.$store.dispatch('product/setProductForm', {
          sales_page: { ...salesPage, ...result },
        });
        return result;
      }
      return salesPage;
    },
    handleSave: debounce(async function (
      this,
      salesPageId: number,
      section: string,
      identifier: string
    ) {
      const productForm = cloneDeep(this.productForm);

      // get request action from section id
      const hasSectionId = has(productForm, `sales_page.${identifier}.id`);
      const action = hasSectionId ? 'update' : 'create';

      // get payload
      const payload = get(productForm, `sales_page.${identifier}`);

      // set image if available
      const sectionImage = get(
        productForm,
        `sales_page.${identifier}.image_obj.id`,
        null
      );
      set(payload, 'image', sectionImage);

      try {
        // prepare data for submit
        const data = {
          product: this.productId,
          salesPage: salesPageId,
          section: section,
          payload: payload,
        };

        // dispatch
        const result = await this.$store.dispatch(
          `product/${action}SalePageSection`,
          data
        );
        // reassign response to product from
        set(productForm, `sales_page.${identifier}`, result);
        this.$store.dispatch('product/setProductForm', productForm);
      } catch (err) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('GENERAL.ERROR.GENERAL_ERROR') as string,
          text: err,
          duration: -1, // stay ON
        });
      }
    },
    500),
    /*
     * Point of this function is to update nested fields of the object;
     *
     *
     * section is url for current section;
     * identifier is root element name. For example we can take introduction;
     * identifierValue is previous object field name. We enter field name we wanted to be changed;
     */
    async handleOnValueInput(
      value: any,
      section: string,
      identifier: string,
      identifierValue: string
    ): Promise<void> {
      let productSalesPage = await this.createOrReturnProductSalesPage();
      productSalesPage = set(
        productSalesPage,
        `${identifier}.${identifierValue}`,
        value
      );

      this.$store.dispatch('product/setProductForm', {
        sales_page: cloneDeep(productSalesPage),
      });

      this.handleSave(productSalesPage.id, section, identifier);
    },
    /*
     * Point of this function is to update full object;
     *
     *
     * section is url for current section;
     * identifier is root element name. For example we can take introduction;
     */
    async handleOnObjectInput(
      value: any,
      section: string,
      identifier: string
    ): Promise<void> {
      let productSalesPage = await this.createOrReturnProductSalesPage();
      productSalesPage = set(productSalesPage, identifier, value);

      this.$store.dispatch('product/setProductForm', {
        sales_page: cloneDeep(productSalesPage),
      });

      this.handleSave(productSalesPage.id, section, identifier);
    },
  },
});
